module.exports = "/_next/static/pages/remote-proctoring/ea5563ad4695e8f1be21e922c7656dd7.png";